import { QueryClient } from "@tanstack/react-query";

/**
 * The app's one react-query cache. `App.tsx` provides it to React; code
 * outside React (`ScanModel.create`) writes to it directly, which is why it
 * lives in its own module rather than inside `App.tsx`.
 */
export const queryClient = new QueryClient();
